import { useDeprecatedFieldsContext } from '../contexts';
/** Returns whether a field is deprecated in the current note schema. Populated in note schema constants ( useDeprecatedFields ). */
export var useFieldIsDeprecated = function (name) {
    var deprecatedFields = useDeprecatedFieldsContext().deprecatedFields;
    return deprecatedFields.includes(name);
};
